<script type="application/javascript">

export default {
    props: ['allPlans'],
    data() {
        return {
            deal: null,
            plan: null,
            showBasic: true,
            checkoutOpen: false,
            plans: [],
            plansType: 'monthly',
        };
    },
    mounted() {
        this.plans = JSON.parse(this.allPlans);

        this.$eventHub.$on('toggleOpenCheckout', function () {
            this.checkoutOpen = !this.checkoutOpen;
        }.bind(this));
        this.$eventHub.$on('toggleOpenContactFormCheckout', function () {
            this.contactFormCheckout = !this.contactFormCheckout;
        }.bind(this));
    },
    methods: {
        openCheckout(deal) {
            // this.deal = this.plan.id;
            this.deal = deal;
            this.checkoutOpen = true;
            dataLayer.push({
                event: 'clickOpenCheckout',
                plan: this.deal.id,
                planType: this.plansType
            });
        }
    },
};
</script>



// WEBPACK FOOTER //
// resources/js/frontend/components/WhitelabelPricingPage.vue